export class ErrorLevelWarning extends Error {}
